import { render, staticRenderFns } from "./ModalBan.vue?vue&type=template&id=2d3b3bfa&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"
import style0 from "./ModalBan.vue?vue&type=style&index=0&id=2d3b3bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b3bfa",
  null
  
)

export default component.exports